export default "__VITE_ASSET__C$zU2Kr___"